import "../../scss/shortcodes/tickets.scss";
import {fireSelects} from "../components/select";
import {tabsHandler} from "../components/tabs";

const ticketsContainer = document.querySelector(".tickets_container");
let activeTickets = ticketsContainer.querySelector('.tab-content.active');
let selectContainer = document.querySelectorAll(".select-container");
const siteUrl = window.location.origin;

let loader = '<div style="position:absolute;z-index:9999;top:0;left:0;width:100%;height:100%;background: #3c3c3c8c;">' +
    '<div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:#333;font-size:2rem">' +
    '<div class="loader">\n' +
    '            <div></div>\n' +
    '            <div></div>\n' +
    '        </div>' +
    '</div>' +
    '</div>';


document.addEventListener("DOMContentLoaded", function(event) {
    fireSelects();
});

selectContainer.forEach((element) => {

let options = element.querySelectorAll(".option");
    options.forEach((option) => {
        option.addEventListener("click", () => {

            let casinoOption = document.getElementById("casinoOptions").querySelector('.selected');
            let sortByOption = document.getElementById("sortByOptions").querySelector('.selected');
            let sortByFilterType = sortByOption.dataset.type;
            let sortByFilterValue = sortByOption.dataset.value;

            let activeFilter = option.dataset.filter;
            let filterType = option.dataset.type;
            let valueToSort = option.dataset.value;
            let perPage = activeTickets.dataset.perpage;
            let casino = casinoOption.dataset.value;
            let casinoPage = casinoOption.dataset.casinopage;

            if (activeFilter){
                let filterTexts = document.querySelectorAll('.sort-filter-text');
                Array.from(filterTexts).forEach((filterText) => {
                    const activeFilterText = filterText.dataset.filter;
                    if (activeFilter === activeFilterText) {
                        filterText.classList.remove("d-none")
                    } else {
                        filterText.classList.add("d-none")
                    }
                });
            }

            switch (filterType) {
                case 'date':
                    fetchTickets(
                        casino,
                        perPage,
                        1,
                        'desc',
                        valueToSort,
                        casinoPage === 'true' ? valueToSort : ''
                    );
                    break;
                case 'sort': // Value of foo matches this criteria; execution starts from here
                    fetchTickets(
                        casino,
                        perPage,
                        1,
                        valueToSort,
                        '',
                        casinoPage === 'true' ? valueToSort : ''
                    );
                    break;
                case 'casino':
                    fetchTickets(
                        valueToSort,
                        perPage,
                        1,
                        sortByFilterType === 'sort' ? sortByFilterValue : 'desc',
                        sortByFilterType === 'date' ? sortByFilterValue : '',
                        casinoPage === 'true' ? valueToSort : '');
                    break;
                default:
                    console.log("default");
            }
        });

    });
});

document.querySelector(".tickets_container").addEventListener("click", function (page) {
    if (page.srcElement.parentElement.classList.contains('active') || !page.srcElement.classList.contains('page-link')) {
        return false;
    }
    page.srcElement.parentElement.classList.add("active");
    fetchPaginatedTickets(page.srcElement.dataset.casino ?? '', page.srcElement.dataset.perpage, page.srcElement.dataset.current ?? 1, page.srcElement.dataset.sort ?? 'desc', page.srcElement.dataset.date ?? '', page.srcElement.dataset.casinopage ?? '');
});


let tabButtons = document.querySelectorAll(".tickets-tab");
let tabContent = document.querySelectorAll(".tab-content");
tabsHandler(tabButtons,tabContent);

function fetchTickets(casino, perPage, page, sort, date, casinoPage) {
    let activeTicketsTab = document.querySelector('.tab-content.active')
    let ajaxUrl = siteUrl + '/ajaxFunctions/fetchTickets';

    activeTicketsTab.insertAdjacentHTML('beforeend', loader);

    fetch(ajaxUrl, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json',
        },
        body: JSON.stringify({
            "sort": sort ?? 'desc',
            "perPage": perPage ?? 10,
            "casino": casino ?? '',
            "casinoPage": casinoPage ?? '',
            "date": date ?? '',
        })
    })
        .then(
            response => response.json()
        )
        .then(data => {
            let jsonData = JSON.parse(data.html);
            document.querySelectorAll(".tickets-tab").forEach((element) => {
                let tabStatus = element.dataset.tab;
                element.querySelector('.count').innerText = jsonData[`${tabStatus}`].count;
                document.querySelector(`.tab-content[data-status=${tabStatus}]`).innerHTML = jsonData[`${tabStatus}`].view;
            });
        })
        .catch(function (error) {
            console.log(error);
        });
}

function fetchPaginatedTickets(casino, perPage, page, sort, date, casinoPage) {
    let activeTicketsTab = document.querySelector('.tab-content.active')
    let status = activeTicketsTab.dataset.status;
    let ajaxUrl = siteUrl + '/ajaxFunctions/fetchPaginatedTickets';

    activeTicketsTab.insertAdjacentHTML('beforeend', loader);

    fetch(ajaxUrl, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json',
        },
        body: JSON.stringify({
            "status": status ?? '',
            "page": page ?? 1,
            "sort": sort ?? 'desc',
            "perPage": perPage ?? 10,
            "casino": casino ?? '',
            "casinoPage": casinoPage ?? '',
            "date": date ?? '',
        })
    })
        .then(
            response => response.json()
        )
        .then(data => {
            activeTicketsTab.innerHTML = data.html;
        })
        .catch(function (error) {
            console.log(error);
        });
}

